import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import PastQBankBlock from '../../../components/Global/PastQBankBlock';
import { Block, StudySessionWithBlocks } from '../../../types/Study';
import { fetchAllExamSessionsAndBlocks } from '../../../services/studySession';
import { examsSelectors } from '../../../slices/exams/examsSlice';
import Page from '../../../components/Page';
import { useStudyPhaseSend } from '../../../studyPhase';
import FlashLoader from '../../../components/FlashLoader';

const PastBlocks: React.FC = () => {
  const primaryExam = useSelector(examsSelectors.selectPrimaryExam);
  const [isLoading, setIsLoading] = useState(true);

  const { sendPhaseEvent } = useStudyPhaseSend();

  const [pastSessionsWithBlocks, setPastSessionsWithBlocks] = useState([]);

  useEffect(() => {
    fetchPastStudySessionsWithBlocks();
  }, [primaryExam]);

  const fetchPastStudySessionsWithBlocks = async () => {
    if (primaryExam) {
      const loadSessions = async () => {
        try {
          const response = await fetchAllExamSessionsAndBlocks(primaryExam.id);
          setPastSessionsWithBlocks(response);
        } finally {
          setIsLoading(false);
        }
      };
      loadSessions();
    }
  };

  const renderPastSessions = () => {
    const filteredSessions = pastSessionsWithBlocks.filter(
      (session: StudySessionWithBlocks) => session.blocks.length > 0
    );

    if (filteredSessions.length === 0) {
      return <div>No past study sessions available.</div>;
    } else {
      return filteredSessions.map((session: StudySessionWithBlocks) => {
        return (
          <>
            <h2 id={session.id}>
              {moment(session.date).format('MMMM D, YYYY')}
            </h2>
            {session.blocks
              .sort((a, b) => (a.ord ?? 0) - (b.ord ?? 0))
              .map((block: Block) => {
                return (
                  <PastQBankBlock
                    key={block.id}
                    title={`Block ${(block.ord ?? 0) + 1}`}
                    blockType={block.type}
                    questionCount={block.vignetteCount}
                    correctCount={block.correctCount}
                    incorrectCount={block.incorrectCount}
                    omittedCount={block.omittedCount}
                    reviewBlockFunction={() => {
                      sendPhaseEvent({
                        type: 'REVIEW_PAST_QBANK',
                        blockId: block.id,
                      });
                    }}
                  />
                );
              })}
          </>
        );
      });
    }
  };

  return (
    <Page type={'past-blocks'}>
      <div className="exam-title">
        <span>{primaryExam?.name}</span>
        <h1>Previous blocks</h1>
      </div>
      {renderPastSessions()}
      <FlashLoader visible={isLoading} />
    </Page>
  );
};

export default PastBlocks;
